import styled, { css } from "styled-components";

interface IProps {
  photo?: string;
}

export const Icon = styled.div<IProps>`
  background: url(${(props) => props.photo});
  background-repeat: no-repeat;
  background-size: 24px;
  width: 24px;
  height: 24px;
  margin-right: 10px;
`;

export const UserProfileContainer = styled.div<IProps>`
  display: flex;
  width: 100%;
  height: 100%;
  padding: 0;

  margin-top: 6rem;

  @media (max-width: 990px) {
    margin-top: 2rem;
  }

  ${({ theme }) =>
    theme.mode === "dark"
      ? css`
          .profile {
            background: rgba(30, 30, 30, 0.6);
            box-shadow: 15px 15px 30px rgba(0, 0, 0, 0.05);

            h1,
            p,
            span,
            b,
            .description {
              color: #ffffff !important;
            }

            .link {
              color: #000000 !important;
            }

            .description {
              background: rgba(44, 44, 44, 0.5);
            }
          }
        `
      : css`
          .profile {
            background: rgba(255, 255, 255, 0.6);
            box-shadow: 15px 15px 30px rgba(0, 0, 0, 0.02);
          }
        `}

  .icon {
    display: flex;
    justify-content: center;

    height: 100vh;
    width: calc(100% - 13px);
    pointer-events: none;

    overflow: hidden;

    position: absolute;
    left: 0;
    top: 0;

    svg {
      & + svg {
        margin-top: 700px;
      }

      path {
        fill: ${({ theme }) => theme.colors.primary};
      }
    }
  }

  .content {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    width: 100%;
    height: max-content;

    z-index: 1;

    .profile {
      display: flex;
      flex-direction: column;
      flex: 3;
      max-width: 1050px;
      width: 100%;
      margin-right: 0.75rem;
      backdrop-filter: blur(100px);
      border-radius: 25px;
      margin-bottom: 3.375rem;

      .body {
        display: flex;
        flex-direction: column;
        padding: 0 4.5rem 3.375rem;
      }
    }
  }

  @media (max-width: 1268px) {
    .content .profile .body {
      padding: 0 2rem 2rem;
    }
  }

  @media (max-width: 1024px) {
    .content {
      flex-direction: column;
      align-items: center;
    }

    .content .profile {
      margin-bottom: 1.25rem;
    }
  }
`;

export const UserNotFindMessageContainer = styled.div`
  font: 500 1.4rem/1.5rem "Inter";

  text-align: center;

  margin-top: 7rem;

  &,
  p {
    color: ${({ theme }) => theme.console.sidebar.titleColor};
  }

  p {
    font: 500 1rem/1.5rem "Inter";

    margin-top: 0.5rem;
  }
`;
